import React from "react";

function FlapSurgeries() {
  return <div>FlapSurgeries</div>;
}

export default FlapSurgeries;
